import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../utils/domain/routingComponents'
import {
  CustomersAndOrdersViewAccessControl,
  CustomerDetailViewAccessControl,
} from '../access-control/customersAndOrdersAdminAccess.configuration'

const CustomersAndOrdersAdminPage = lazy(
  () =>
    import(
      /* webpackChunkName: "CustomersAndOrdersAdminPage" */
      '../pages/admin/customers-and-orders/CustomersAndOrdersAdminPage'
    )
)

const CustomersAndOrdersCustomerDetailPage = lazy(
  () =>
    import(
      /* webpackChunkName: "CustomersAndOrdersAdminPage" */
      '../pages/admin/customers-and-orders/CustomersAndOrdersCustomerDetailPage'
    )
)

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const customersAndOrdersAdminRouter = (
  <DomainRoute route="app-admin-customers-and-orders">
    <DashSwitch>
      <DomainRedirect
        fromRoute="app-admin-customers-and-orders-dashboard"
        toRoute="app-admin-customers-and-orders-dashboard-legacy"
        exact
      />
      <DomainRoute
        exact
        route="app-admin-customers-and-orders-ipp-customer-details"
        component={CustomersAndOrdersCustomerDetailPage}
        accessControl={CustomerDetailViewAccessControl}
      />
      <DomainRoute
        route="app-admin-customers-and-orders-dashboard-wildcard"
        component={CustomersAndOrdersAdminPage}
        accessControl={CustomersAndOrdersViewAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
